<template>
  <b-modal
    class="deleteApiKeyModal"
    hide-header
    hide-footer
    centered
    ref="deleteApiKeyModal"
    @open="open"
  >
    <b-form @submit="onSubmit" @reset="onReset" class="p-4">
      <b-row>
        <b-col>
          <p>Do you really want to revoke this key?</p>
        </b-col>
      </b-row>
      <b-row class="form-actions">
        <b-col>
          <p-button type="success" round size="sm" class="pull-right" :disabled="processing" @click.native="onSubmitForm" :loading="processing">Yes</p-button>
          <p-button type="danger" round size="sm" class="pull-right mr-2" @click.native="onCancel">No</p-button>
        </b-col>
      </b-row>
    </b-form>
    <b-loading :loading="processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'

export default {
  data() {
    return {
      processing: false,
      initial: {
        key: ''
      },
      form: {
        key: '',
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ])
  },
  methods: {
    open(item) {
      this.initial.key = item.key
      this.resetFormFields()
      this.$refs.deleteApiKeyModal.show()
    },
    close() {
      this.$refs.deleteApiKeyModal.hide()
    },
    onSubmit() {
      this.onSubmitForm()
    },
    onCancel() {
      this.close()
    },
    onReset() {
      this.resetFormFields()
    },
    resetFormFields() {
      this.form = {
        ...this.initial
      }
      this.processing = false
    },
    onSubmitForm(e) {
      e && e.preventDefault()
      this.processing = true
      const {error, ...payload} = this.form
      this.$store.dispatch('deleteApiKey', payload)
      // .then((response) => console.log(response))
      .finally(() => {
        this.processing = false
        this.close()
      })
    }
  },
  created() {
    this.resetFormFields()
  },
}
</script>
<style lang="scss">
.deleteApiKeyModal {
  .modal-header {
    border-bottom: 0 none;
  }
  .form-control {
    border: solid 1px #ccc;
  }
  .form-actions {
    .btn {
      min-width: 100px;
    }
  }
}
</style>
